import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";

const RequestSignup = (props) => {
  const { showPopUp, onButtonClick, titleInfo } = props;
  const history = useHistory();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const [storeUrl, setStoreUrl] = useState("");
  const appData = JSON.parse(sessionStorage.getItem("applicationData"));

  useEffect(() => {
    getMobileOperatingSystem();
  }, []);

  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const iosLink = appData?.app?.appStoreUrl;
    const androidLink = appData?.app?.googlePlayStoreUrl;

    if (/windows phone/i.test(userAgent)) {
      setStoreUrl(androidLink);
    } else if (/android/i.test(userAgent)) {
      setStoreUrl(androidLink);
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setStoreUrl(iosLink);
    } else {
      setStoreUrl(androidLink);
    }
  };

  return (
    <Box>
      <Dialog open={showPopUp} className="app-dialog" onClose={onButtonClick}>
        <DialogContent
          sx={{
            padding: "40px",
            width: matchesMinWidth ? undefined : "540px",
            // height: "360px",
            textAlign: "center",
          }}
        >
          <Box mb={4}>
            <Typography
              variant="h2LatoBold"
              dangerouslySetInnerHTML={{ __html: titleInfo }}
              sx={{ fontSize: matchesMinWidth ? "16px" : undefined }}
            ></Typography>
          </Box>
          <Box mb={4}>
            <Typography
              variant="h2LatoMedium"
              sx={{
                fontWeight: 500,
                color: "#607277",
                fontSize: matchesMinWidth ? "15px" : undefined,
              }}
            >
              Sign up for an account or download the{" "}
              {matchesMinWidth ? null : <br />} mobile app to access this
              feature.
            </Typography>
          </Box>
          <Box mb={4}>
            <Button
              variant="outline"
              sx={{
                width: matchesMinWidth ? "100%" : "100%",
                minWidth: matchesMinWidth ? "30px" : undefined,
                fontSize: matchesMinWidth ? "12px" : "20px",
                fontFamily: "Lato-Bold",
              }}
              onClick={() => {
                onButtonClick();
                history.push("/sign-up");
              }}
            >
              SIGN UP FOR AN ACCOUNT
            </Button>
          </Box>
          <Box mb={4}>
            <Button
              variant="outline"
              sx={{
                width: matchesMinWidth ? "100%" : "100%",
                minWidth: matchesMinWidth ? "30px" : undefined,
                fontSize: matchesMinWidth ? "12px" : "20px",
                fontFamily: "Lato-Bold",
              }}
              onClick={() => {
                onButtonClick();
                history.push("/SignIn");
              }}
            >
              SIGN IN TO AN ACCOUNT
            </Button>
          </Box>
          <Box>
            <a
              rel="noreferrer"
              target="_blank"
              style={{ textDecoration: "none" }}
              href={storeUrl}
            >
              <Button
                variant="large"
                sx={{
                  width: "100%",
                  minWidth: matchesMinWidth ? "200px" : undefined,
                  fontSize: matchesMinWidth ? "12px" : undefined,
                  // display: matchesMinWidth ? 'block' : 'none'
                }}
                onClick={() => onButtonClick()}
              >
                Download the mobile app
              </Button>
            </a>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RequestSignup;
